import React, { useEffect, useMemo, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Ptag } from "components/core/fonts";
import { FlexRow } from "pages/UniversalSetup/UniversalCorporateBuffer/bufferCard";
import calender from "assets/svgs/calenderIcon.svg";
import { Image } from "@mui/icons-material";
import { Divider } from "@mui/material";
import { Form, Formik } from "formik";
import BaseDateInput from "./BaseDateInput";
import { useMatch } from "react-router";
import * as Yup from "yup";
import http from "services/httpService";
import { colors } from "theme";

const validationSchema = Yup.object().shape({
  cutoff_date: Yup.date()
    .min(new Date(), "*Cutoff Date cannot be a past date")
    .required("*Cutoff Date is required"),
});

function SingleDialogBox({ open, close, taskData }) {
  const cutoffDate = useMemo(() => {
    return taskData["Cut-Off Date"];
  }, [taskData]);

  const handleSubmit = async (values) => {
    try {
      console.log("Form submitted with values:", values);
      const cutoff_date = values.cutoff_date;
      const payload = {
        cutoff_date,
        async_task_id: taskData.async_task_id,
      };
      const { data } = await http.post(
        "business/update_cut_off_data_for_batch/",
        payload
      );
      close("");
      window.location.reload();
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "35%",
              maxWidth: "300px",
              backgroundColor: "#FDFAFF",
              borderRadius: "15px",
              paddingTop: "8px",
            },
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {/* <Ptag>Edit</Ptag> */}
          <FlexRow
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.4rem",
            }}
          >
            <Ptag fontSize="18px" fontWeight="500">
              Enter Date
            </Ptag>
            {/* <img src={calender} /> */}
          </FlexRow>
          <Divider />
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Formik
              enableReinitialize
              validationSchema={validationSchema}
              initialValues={{ cutoff_date: cutoffDate }}
              validateOnBlur={false}
              validateOnChange={true}
              onSubmit={(values) => handleSubmit(values)}
            >
              {(formikProps) => (
                <Form>
                  <div style={{ width: "100%" }}>
                    <BaseDateInput
                      onlyFutureDate={true}
                      formikProps={{ ...formikProps, name: "cutoff_date" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      paddingTop: "3rem",
                      gap: "1rem",
                    }}
                  >
                    <Button
                      onClick={() => close("")}
                      style={{ ...textStyle, color: colors.primaryColor }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      // onClick={() => close("")}
                      style={{ ...textStyle, background: colors.primaryColor }}
                      type="submit"
                    >
                      Ok
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={() => close("")} style={textStyle}>
            Cancel
          </Button>
          <Button onClick={() => close("")} style={textStyle} type="sumit">
            Ok
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}

export default SingleDialogBox;
const textStyle = {
  textTransform: "none",
  fontSize: "12px",
  fontWeight: "400",
};
